import { Chip, Stack } from "@mui/joy";
import { useCallback, useState } from "react";
import {
  useMediaDataRoom,
  useMediaDataRoomInsightsData,
} from "features/mediaDataRoom/contexts";
import DataNodeItem from "../DataNodeItem";
import PublishedDataNodeContent from "./PublishedDataNodeContent/PublishedDataNodeContent";
import PublisherDataNodeActions from "./PublisherDataNodeActions/PublisherDataNodeActions";

const BaseAudienceDataNode: React.FC = () => {
  const {
    publishedDatasetsHashes: { hasPublisherData },
  } = useMediaDataRoomInsightsData();
  const {
    supportedFeatures: { canViewBaseAudienceDetails },
    baseAudienceProviderName,
  } = useMediaDataRoom();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const toggleCollapse = useCallback(
    () => setIsCollapsed((state) => !state),
    [setIsCollapsed]
  );
  const hasUploadingDescription =
    hasPublisherData && canViewBaseAudienceDetails;
  return (
    <DataNodeItem
      actions={<PublisherDataNodeActions isProvisioned={hasPublisherData} />}
      content={hasUploadingDescription ? <PublishedDataNodeContent /> : null}
      isCollapsed={isCollapsed}
      title={
        <Stack direction="row" gap={1}>
          <span>Base audience</span>
          {baseAudienceProviderName && <Chip>{baseAudienceProviderName}</Chip>}
        </Stack>
      }
      toggleCollapse={hasUploadingDescription ? toggleCollapse : undefined}
    />
  );
};
BaseAudienceDataNode.displayName = "BaseAudienceDataNode";

export default BaseAudienceDataNode;
